import type { IANATimezones, NextReassessment } from '@gcv/shared';

import { RISK_ASSESSMENT_FREQUENCY_LABELS } from 'ui/apps/fi/shared/types';
import { DateTimeHelpers } from 'util/dateTime.util';

/** The next-assessment line. No upcoming reassessment means none is scheduled, not never. */
export const formatNextReassessment = (
  next?: NextReassessment,
  timezone?: IANATimezones
): { date: string; detail: string } => {
  if (!next) {
    return { date: 'Not scheduled', detail: 'No recurring risk assessment is scheduled for this account.' };
  }

  const frequency = RISK_ASSESSMENT_FREQUENCY_LABELS[next.frequency];

  return {
    date: DateTimeHelpers.formatISOToFriendlyDateString(next.date, timezone),
    detail: [next.template_name, frequency].filter(Boolean).join(' · ')
  };
};
